import { InjectionToken } from "@angular/core";

// Create the injection token for the custom settings
export const RED_ICON = new InjectionToken('redIcon');
